// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"7164364c57e30028da7c","873":"7e12039ebe16b6107a7e"}[chunkId] + ".js";
};